import { createBrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import ProtectedRoute from './auth/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import InvitePage from './pages/InvitePage';
import DemoEntryPage from './pages/DemoEntryPage';
import DashboardPage from './pages/DashboardPage';
import AnalysesPage from './pages/AnalysesPage';
import AnalysisDetailPage from './pages/AnalysisDetailPage';
import WorkItemDetailPage from './pages/WorkItemDetailPage';
import DevelopersPage from './pages/DevelopersPage';
import ProjectsPage from './pages/ProjectsPage';
import SettingsPage from './pages/SettingsPage';
import BillingPage from './pages/BillingPage';
import OnboardingCallbackPage from './pages/OnboardingCallbackPage';
import OnboardingErrorPage from './pages/OnboardingErrorPage';
import NotFoundPage from './pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      // Public auth routes.
      { path: '/login', element: <LoginPage /> },
      { path: '/signup', element: <SignupPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
      { path: '/reset-password', element: <ResetPasswordPage /> },
      { path: '/verify-email', element: <VerifyEmailPage /> },
      { path: '/invite/:token', element: <InvitePage /> },
      // Read-only demo workspace with sample data — public entry, no signup.
      { path: '/demo', element: <DemoEntryPage /> },
      // Onboarding callback handles "not logged in yet" by bouncing to /signup with the
      // installation_id pre-filled.
      { path: '/onboarding/callback', element: <OnboardingCallbackPage /> },
      { path: '/onboarding/error', element: <OnboardingErrorPage /> },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <Layout />,
            children: [
              { path: '/', element: <Navigate to="/dashboard" replace /> },
              { path: '/dashboard', element: <DashboardPage /> },
              { path: '/analyses', element: <AnalysesPage /> },
              { path: '/analyses/:id', element: <AnalysisDetailPage /> },
              { path: '/work-items/:scope/:id/:author', element: <WorkItemDetailPage /> },
              { path: '/projects', element: <ProjectsPage /> },
              { path: '/developers', element: <DevelopersPage /> },
              { path: '/billing', element: <BillingPage /> },
              { path: '/settings', element: <SettingsPage /> },
            ],
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
